export const initialValuesReset = {
  code: '',
  password: '',
};
